import { makeStyles } from "@material-ui/core";
import { h4Medium, h5Medium, h6Medium, h7Regular } from "../../../shared/typography";
import { pointer, withOpacity } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  container: {
    ...h6Medium,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 24,
    maxWidth: 540,
    width: "100%",
    minHeight: 260,
    border: "1px dashed lightgrey",
    borderRadius: 16,
    background: "none",
    color: "#80BB34",
    ...pointer,
    "&:disabled": {
      ...withOpacity(0.6),
      cursor: "default",
    },
  },
  plus: {
    width: 48,
    height: 48,
  },
  link: {
    ...h6Medium,
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "none",
    border: "none",
    padding: 0,
    color: "#80BB34",
    ...pointer,
    "&:disabled": {
      ...withOpacity(0.6),
      cursor: "default",
    },
  },
  linkPlus: {
    width: 20,
    height: 20,
  },

  // Add card confirmation modal
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    padding: "32px 48px",
    background: "#fff",
    borderRadius: 16,
    width: 320,
    boxSizing: "border-box",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 16,
  },
  modalTitle: {
    ...h4Medium,
  },
  modalCloseIcon: {
    padding: 16,
    margin: "-16px",
    ...pointer,
  },
  modalMessage: {
    ...h7Regular,
    opacity: 0.64,
    marginTop: 16,
  },
  modalConfirmButton: {
    margin: "32px 0 24px 0",
    height: 56,
    background: "#80BB34",
    color: "#FFF",
    ...h5Medium,
    border: "none",
    width: "100%",
    borderRadius: 16,
    ...pointer,
  },
  modalNotNow: {
    ...h6Medium,
    color: "#80BB34",
    display: "flex",
    justifyContent: "center",
    ...pointer,
  },
}));
